import React from "react";
import LinkedIn from "../../assets/linkedin 1.png";
import GitHub from "../../assets/github 1.png";
import FaceBook from "../../assets/facebook 1.png";
import ReactLogo from "../../assets/React.png";
import FlutterLogo from "../../assets/Flutter.png";
import TypeScriptLogo from "../../assets/TS.png";
import JavaScriptLogo from "../../assets/JS.png";
import ReactNativeLogo from "../../assets/ReactNative.png";
import HTMLLogo from "../../assets/HTML.png";
import CSSLogo from "../../assets/CSS.png";
import TailwindLogo from "../../assets/Tailwind.png";
import leftArrow from "../../assets/ icon _arrow_left.png";
import rightArrow from "../../assets/ icon _arrow_right.png.png";
import SkillButton from "./skillButton";
import SkillsDescriptions from "./SkillsDescriptions";

const Skills = () => {
  return (
    <>
      <div
        id="skills"
        className="bg-space h-[100vmin] bg-fill bg-no-repeat text-white bg-[center_right_62%] pt-12 px-[4.4rem]"
      >
        <h2 className="m-4 text-[5vmin] font-bold">Skills</h2>
        <div className="grid justify-center">
          <div className="h-[35vh] w-[45vw] rounded-2xl bg-white backdrop-blur bg-white/10 grid items-center self-center justify-center content-center">
            <div className="grid  grid-cols-4 gap-4 px-4 items-center self-center content-center justify-center w-[45vw] ">
              <SkillButton />
            </div>
          </div>
          <div className="grid justify-center mt-8 ">
            <div className="h-[20vh] w-[38vw] text-center rounded-2xl bg-white backdrop-blur bg-white/10 grid items-center self-center justify-center content-center p-[4vmin]">
              <SkillsDescriptions />
            </div>
          </div>
          <div className="grid justify-center mt-8 ">
            <div className="h-[6vh] w-[25vw] grid-cols-6 rounded-2xl bg-white backdrop-blur bg-white/10 grid items-center self-center justify-center content-center">
              <div className="grid justify-center">
                <img src={leftArrow} alt="" />
              </div>
              <div className="col-span-4 text-center">
                <p>Front-End Development</p>
              </div>
              <div className="grid justify-center">
                <img src={rightArrow} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Skills;
